
<mat-toolbar>

    <!-- Sponsors -->
    <mat-toolbar-row class="h-auto p-0">
        <app-sponsors-toolbar class="w-100"></app-sponsors-toolbar>
    </mat-toolbar-row>
    
    <!-- Footer -->
    <mat-toolbar-row class="h-auto p-0">    
        <app-footer-menu class="w-100"></app-footer-menu>
    </mat-toolbar-row>

</mat-toolbar>